// Runtime configuration cache
let runtimeConfig: Record<string, string> | null = null;

/**
 * Fetch runtime configuration from the server
 */
export const fetchRuntimeConfig = async (): Promise<Record<string, string>> => {
  if (runtimeConfig) {
    return runtimeConfig;
  }

  try {
    const response = await fetch('/api/config');
    if (!response.ok) {
      throw new Error(`Failed to fetch config: ${response.status}`);
    }
    const config = await response.json();
    runtimeConfig = config;
    return config;
  } catch (error) {
    console.error('Failed to load runtime configuration, falling back to build-time env vars:', error);

    // Fallback to build-time environment variables
    const fallbackConfig = {
      REACT_APP_AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID || '',
      REACT_APP_AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID || '',
      REACT_APP_AZURE_REDIRECT_URI: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
      REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api',
      REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development'
    };

    runtimeConfig = fallbackConfig;
    return fallbackConfig;
  }
};

/**
 * Get a configuration value by key
 */
export const getConfig = async (key: string): Promise<string> => {
  const config = await fetchRuntimeConfig();
  return config[key] || '';
};

/**
 * Get the backend URL for authentication endpoints
 * In development: uses REACT_APP_BACKEND_URL (e.g., http://localhost:3006)
 * In production: uses empty string for same-origin requests
 */
export const getBackendUrl = (): string => {
  // In production, use relative URLs (same origin)
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  // In development, use the configured backend URL or fallback to localhost:3006
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:3006';
};

/**
 * Build a full URL for backend endpoints
 */
export const buildBackendUrl = (path: string): string => {
  const baseUrl = getBackendUrl();
  return `${baseUrl}${path}`;
};
